exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ContactBox {\n  flex: 0 1 calc(50% - 30px);\n  box-sizing: border-box; }\n  @media (max-width: 1200px) {\n    .ContactBox {\n      flex: 0 0 calc(100% - 30px); } }\n  .ContactBox .ContactBox-PreviewWrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; }\n    .ContactBox .ContactBox-PreviewWrapper strong {\n      text-transform: uppercase;\n      margin-bottom: 15px;\n      margin-right: 20px;\n      padding: 20px;\n      font-size: 0.9em;\n      opacity: 0.3; }\n  .ContactBox .ContactBox-Preview {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 130px;\n    width: 100%;\n    margin-bottom: 60px; }\n    .ContactBox .ContactBox-Preview .ContactBlock {\n      padding: 20px;\n      border-radius: 10px;\n      border: 1px solid rgba(0, 0, 0, 0.05);\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.05); }\n      .ContactBox .ContactBox-Preview .ContactBlock h2 {\n        margin-top: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Forms/ContactBox/ContactBox.scss
// module id = 388
// module chunks = 0